export const getOrganizationSettingsMappingConfig = (key) => ({
  url: `/organization_settings?key=${key}`,
});

export const getSRTypeListConfig = () => ({
  url: `/v3/service_request/types`,
});

export const getSRStatusListConfig = () => ({
  url: `/v3/service_request/statuses`,
});
